import styled from 'styled-components';

import BaseAlert from '@r1-frontend/ui-react/components/Alert';
import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

export const MsgContent = styled.div`
    width: 100%;
`;

export const Text = styled.div`
    flex: 1;
    width: 100%;
    ${FONTS.S};

    @media (max-width: ${wideBreakpoints.mobile}) {
        ${FONTS.XS};
    }
`;

export const NoWrapText = styled.span`
    display: contents;
    white-space: nowrap;
`;

export const BoldText = styled.span`
    display: contents;
    ${FONTS.H5};

    @media (max-width: ${wideBreakpoints.mobile}) {
        ${FONTS.H6};
    }
`;

export const Alert = styled(BaseAlert)`
    flex-direction: column;
    gap: 10px;
    width: 100%;
    align-items: baseline;
    overflow: visible;
`;
